import secureLocalStorage from "react-secure-storage";
import { Dialog } from "@progress/kendo-react-dialogs";
import React, { Component } from "react";
import { Dropdown } from "react-bootstrap";
import "react-dropzone-uploader/dist/styles.css";
import { renderRoutes } from "react-router-config";
import { NavLink } from "react-router-dom";
import Images from "../../Assets/Images";
import { TenantAdminRoute } from "../../Routes/RoutesPath";
import "../../Styles/TenantHeader.scss";
import AuthContext from "../../Context/AuthContext";

export default class TenantHeader extends Component {
  static contextType = AuthContext;
  
  constructor(props) {
    super(props);
    this.state = {
      openMobiMenu: false,
      openapplinks: false,
      showBrowse: false,
      ProfileDialogvisible: false,
      isDropdownVisible: false
    }
  }

  toggleProfileDialog = () => {
    this.setState({
      ProfileDialogvisible: !this.state.ProfileDialogvisible,
    });
  };


  showProfileUpload = () => {
    this.setState({ showBrowse: !this.state.showBrowse });
    
  }
 
  navigatePage = (nav) => {
    secureLocalStorage.setItem('ActivePage', nav);
    // Force a re-render to update the active tab
    this.forceUpdate();
  }
  pageNavLogout = () => {
    let tenantKey = secureLocalStorage.getItem("tenantKey");
    // secureLocalStorage.clear();
    // this.props.history.push(`/tenant/${tenantKey}`);
    window.location.href=`/${'tenant'}/${tenantKey}`;
  };
  showMobileNav = () => {
    this.setState({ openMobiMenu: true });
  };
  showapplinks= () => {

    this.setState({ openapplinks : !this.state.openapplinks})

  }
  
  hideMobileNav = () => {
    this.setState({ openMobiMenu: false });
  }
  changePassword = (e) => {
    e.preventDefault();
    let key = secureLocalStorage.getItem("tenantKey");
    this.props.history.push(`/tenant/${key}/changepassword`);
  };

  componentDidMount() {
    // Set ActivePage based on current URL path
    this.updateActivePageFromURL();
    
    // Add event listener for popstate to handle browser navigation
    window.addEventListener('popstate', this.updateActivePageFromURL);
  }
  
  componentWillUnmount() {
    // Remove event listener when component unmounts
    window.removeEventListener('popstate', this.updateActivePageFromURL);
  }
  
  updateActivePageFromURL = () => {
    const currentPath = window.location.pathname;
    
    if (currentPath.includes('/home/main')) {
      secureLocalStorage.setItem('ActivePage', 'Home');
    } else if (currentPath.includes('/home/unit')) {
      secureLocalStorage.setItem('ActivePage', 'Risks');
    } else if (currentPath.includes('/home/taskmodule')) {
      secureLocalStorage.setItem('ActivePage', 'Task');
    } else if (currentPath.includes('/home/datasets')) {
      secureLocalStorage.setItem('ActivePage', 'Mitigations');
    } else if (currentPath.includes('/home/dashboard/reports')) {
      secureLocalStorage.setItem('ActivePage', 'Reports');
    } else if (currentPath.includes('/home/monteCarlo')) {
      secureLocalStorage.setItem('ActivePage', 'Analytics');
    } else if (currentPath.includes('/home/scenario')) {
      secureLocalStorage.setItem('ActivePage', 'Scenario');
    } else if (currentPath.includes('/home/admin')) {
      secureLocalStorage.setItem('ActivePage', 'Admin');
    } else if (currentPath.includes('/home/prime')) {
      secureLocalStorage.setItem('ActivePage', 'Prime');
    } else if (currentPath.includes('/home/cart')) {
      secureLocalStorage.setItem('ActivePage', 'Cart');
    }
  }

  openDemoVideo(){
    
  }

   handlePdfClick = () => {
    window.open('https://riskwellprotectuat.blob.core.windows.net/help/Riskwell-User-Manual.pdf', '_blank');
  };

 handleVimeoClick = () => {
  window.open('https://vimeo.com/showcase/protecttraining', '_blank');
};
    handleMouseEnter = () => {
    this.setState({
      isDropdownVisible: true,
    });
  };

  // Hide dropdown when mouse leaves
   handleMouseLeave = () => {
    this.setState({
      isDropdownVisible: false,
    });
  };
 
  render() {
    // let {tenantKey} = this.props
    let tenantKey = secureLocalStorage.getItem("tenantKey");
    let name = secureLocalStorage.getItem("userName");
    return (
      <div className="appWrapperTenant">
        <div className="wrapper">
          <div className="appHeader d-flex">
            <div className="heading">
              <ul>
                {/* <li>
                  <a className="appMenu" onClick={this.showapplinks}>
                    
                    <img src={ Images.DOTSMENU } width="12" />
                  </a>

                  <div  className={ this.state.openapplinks ? "extAppCont showAppLinks":"extAppCont" } >
                    <h3>Switch to</h3>
                    <ul>
                      <li>
                        <a>
                          <span class="icons"><img src={Images.PROTECT} width="14" alt="Check"/></span>
                          <p>Protect</p>
                          <span class="activeCheck"><img src={Images.CHECKCIRCLEGREEN} width="18" alt="Check"/></span>
                        </a>
                      </li>
                      <li>
                        <a>
                          <span class="icons">P</span>
                          <p>Pathway</p>
                          <span class="activeCheck"></span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </li> */}
                <li className="menuIco">
                  <a onClick={this.showMobileNav}>
                    <img src={Images.MENU} width="16" />
                  </a>
                </li>
                <li>
                  <a>
                    <img src={Images.RISKWELLLOGO} width="100" />
                  </a>
                </li>
              </ul>
            </div>
            <div className="ml-auto">
              <div className="d-flex">
                <div className="appNav appMainNav">
                  {/* showInMobile */}
                  <ul
                    className={
                      this.state.openMobiMenu ? "smOnly showInMobile" : "smOnly"
                    }
                  >
                    <a className="closeMenu" onClick={this.hideMobileNav}>
                      <img src={Images.CLOSEDWHITE} width="14" alt="Close" />
                    </a>
                    <li>
                      <NavLink
                        className={`link ${
                          secureLocalStorage.getItem("ActivePage") == "Home"
                            ? "Activated"
                            : ""
                        }`}
                        onClick={() => this.navigatePage("Home")}
                        to={`/tenant/${tenantKey}/home/main`}
                      >
                        <span>
                          {" "}
                          <img src={Images.HOME} width="12" alt="Home" />{" "}
                        </span>
                        Home
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className={`link ${
                          window.location.pathname.includes('/home/unit')
                            ? "Activated"
                            : ""
                        }`}
                        onClick={() => this.navigatePage("Risks")}
                        exact
                        to={`/tenant/${tenantKey}/home/unit`}
                      >
                        <span>
                          {" "}
                          <img src={Images.UNIT} width="12" alt="Risks" />{" "}
                        </span>
                        Risks
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className={`link ${
                          window.location.pathname.includes('/home/datasets')
                            ? "Activated"
                            : ""
                        }`}
                        onClick={() => this.navigatePage("Mitigations")}
                        exact
                        to={`/tenant/${tenantKey}/home/datasets`}
                      >
                        <span>
                          {" "}
                          <img
                            src={Images.TEMPLATE}
                            width="12"
                            alt="Mitigations"
                          />{" "}
                        </span>
                        Datasets
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className={`link ${
                          window.location.pathname.includes('/home/dashboard/reports')
                            ? "Activated"
                            : ""
                        }`}
                        onClick={() => this.navigatePage("Reports")}
                        exact
                        to={`/tenant/${tenantKey}/home/dashboard/reports`}
                      >
                        <span>
                          {" "}
                          <img
                            src={Images.DASHBOARD}
                            width="12"
                            alt="Reports"
                          />{" "}
                        </span>
                        Reports
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className={`link ${
                          secureLocalStorage.getItem("ActivePage") ==
                          "Analytics"
                            ? "Activated"
                            : ""
                        }`}
                        onClick={() => this.navigatePage("Analytics")}
                        exact
                        to={`/tenant/${tenantKey}/home/monteCarlo`}
                      >
                        <span>
                          {" "}
                          <img
                            src={Images.ANALYTICS}
                            width="12"
                            alt="Analytics"
                          />{" "}
                        </span>
                        Analytics
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className={`link ${
                          window.location.pathname.includes('/home/scenario')
                            ? "Activated"
                            : ""
                        }`}
                        onClick={() => this.navigatePage("Scenario")}
                        exact
                        to={`/tenant/${tenantKey}/home/scenario`}
                      >
                        <span>
                          {" "}
                          <img
                            src={Images.SCENARIO}
                            width="12"
                            alt="Assignment"
                          />{" "}
                        </span>
                        Scenario
                      </NavLink>
                    </li>

                    {this.context.hasPermission('admin') && (
                      <li>
                        <NavLink
                          className={`link ${
                            window.location.pathname.includes('/home/admin')
                              ? "Activated"
                              : ""
                          }`}
                          onClick={() => this.navigatePage("Admin")}
                          exact
                          to={`/tenant/${tenantKey}/home/admin`}
                        >
                          <span>
                            {" "}
                            <img
                              src={Images.TEMPLATE}
                              width="12"
                              alt="Assignment"
                            />{" "}
                          </span>
                          Admin
                        </NavLink>
                      </li>
                    )}
                  </ul>

                  <ul className="gtSm">
                    <li>
                      <NavLink
                        className={`link ${
                          window.location.pathname.includes('/home/main')
                            ? "Activated"
                            : ""
                        }`}
                        onClick={() => this.navigatePage("Home")}
                        to={`/tenant/${tenantKey}/home/main`}
                      >
                        <span>
                          {" "}
                          <img src={Images.HOME} width="12" alt="Home" />{" "}
                        </span>
                        Home
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className={`link ${
                          window.location.pathname.includes('/home/unit')
                            ? "Activated"
                            : ""
                        }`}
                        onClick={() => this.navigatePage("Risks")}
                        exact
                        to={`/tenant/${tenantKey}/home/unit`}
                      >
                        <span>
                          {" "}
                          <img src={Images.UNIT} width="12" alt="Risks" />{" "}
                        </span>
                        Risks
                      </NavLink>
                    </li>
                    {this.context.hasPermission('tasks') && (
                      <li>
                        <NavLink
                          className={`link ${
                            window.location.pathname.includes('/home/taskmodule')
                              ? "Activated"
                              : ""
                          }`}
                          onClick={() => this.navigatePage("Task")}
                          exact
                          to={`/tenant/${tenantKey}/home/taskmodule`}
                        >
                          <span>
                            <img src={Images.TYPES} width="10" alt="Task" />
                          </span>
                          Tasks
                        </NavLink>
                      </li>
                    )}
                    <li>
                      <NavLink
                        className={`link ${
                          window.location.pathname.includes('/home/datasets')
                            ? "Activated"
                            : ""
                        }`}
                        onClick={() => this.navigatePage("Mitigations")}
                        exact
                        to={`/tenant/${tenantKey}/home/datasets`}
                      >
                        <span>
                          {" "}
                          <img
                            src={Images.TEMPLATE}
                            width="12"
                            alt="Mitigations"
                          />{" "}
                        </span>
                        Datasets
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        id="reportActiveLink"
                        className={`link ${
                          window.location.pathname.includes('/home/dashboard/reports')
                            ? "Activated"
                            : ""
                        }`}
                        onClick={() => this.navigatePage("Reports")}
                        exact
                        to={`/tenant/${tenantKey}/home/dashboard/reports`}
                      >
                        <span>
                          {" "}
                          <img
                            src={Images.DASHBOARD}
                            width="12"
                            alt="Reports"
                          />{" "}
                        </span>
                        Reports
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className={`link ${
                          window.location.pathname.includes('/home/monteCarlo')
                            ? "Activated"
                            : ""
                        }`}
                        onClick={() => this.navigatePage("Analytics")}
                        exact
                        to={`/tenant/${tenantKey}/home/monteCarlo`}
                      >
                        <span>
                          {" "}
                          <img
                            src={Images.ANALYTICS}
                            width="12"
                            alt="Analytics"
                          />{" "}
                        </span>
                        Analytics
                      </NavLink>
                    </li>

                    <li>
                      <NavLink
                        className={`link ${
                          window.location.pathname.includes('/home/scenario')
                            ? "Activated"
                            : ""
                        }`}
                        onClick={() => this.navigatePage("Scenario")}
                        exact
                        to={`/tenant/${tenantKey}/home/scenario`}
                      >
                        <span>
                          {" "}
                          <img
                            src={Images.SCENARIO}
                            width="12"
                            alt="Assignment"
                          />{" "}
                        </span>
                        Scenarios
                      </NavLink>
                    </li>
                    <li className="cart">
                      <NavLink
                        className={`link ${
                          window.location.pathname.includes('/home/cart')
                            ? "Activated"
                            : ""
                        }`}
                        onClick={() => this.navigatePage("Cart")}
                        exact
                        to={`/tenant/${tenantKey}/home/cart`}
                      >
                        <span>
                          {" "}
                          <img
                            src={Images.EMAIL}
                            width="16"
                            alt="Assignment"
                          />{" "}
                        </span>
                        Email
                      </NavLink>
                    </li>
                    {this.context.hasPermission('admin') && (
                      <li>
                        <NavLink
                          className={`link ${
                            window.location.pathname.includes('/home/admin')
                              ? "Activated"
                              : ""
                          }`}
                          onClick={() => this.navigatePage("Admin")}
                          exact
                          to={`/tenant/${tenantKey}/home/admin`}
                        >
                          <span>
                            {" "}
                            <img
                              src={Images.USER}
                              width="12"
                              alt="Assignment"
                            />{" "}
                          </span>
                          Admin
                        </NavLink>
                      </li>
                    )}
                    {/* Use AuthContext for Prime tab visibility */}
                    {this.context.hasPermission('prime') && (
                      <li>
                        <NavLink
                          className={`link ${
                            window.location.pathname.includes('/home/prime')
                              ? "Activated"
                              : ""
                          }`}
                          onClick={() => this.navigatePage("Prime")}
                          exact
                          to={`/tenant/${tenantKey}/home/prime`}
                        >
                          <span>
                            <img src={Images.TYPES} width="10" alt="Prime" />
                          </span>
                          Prime
                        </NavLink>
                      </li>
                    )}

                    {/* <li>
                      <li
                        className={`link ${
                          secureLocalStorage.getItem("ActivePage") == "Demo"&&""
                        }`}
                        onClick={() => this.openDemoVideo()}
                        exact
                        to={`/tenant/${tenantKey}/home/demo`}
                      >
                        <span>
                          <img src={Images.PLAY} width="10" alt="Demo" />
                        </span>
                        Help
                      </li>
                    </li> */}
                    <li>
                      <li
                        onMouseEnter={this.handleMouseEnter}
                        onMouseLeave={this.handleMouseLeave}
                        exact
                        className={`link help manual-link ${
                          secureLocalStorage.getItem("ActivePage") == "Demo" &&
                          ""
                        }`}
                        onClick={() => this.openDemoVideo()}
                        to={`/tenant/${tenantKey}/home/demo`}
                      >
                        <span>
                          <img src={Images.PLAY} width="10" alt="Demo" />
                        </span>
                        Help
                        {/* Dropdown menu, visible only when isDropdownVisible is true */}
                        {this.state.isDropdownVisible && (
                          <ul className="dropdown list-group">
                            <li
                              className="dropdown-option list-group-item"
                              onClick={this.handlePdfClick}
                            >
                              User Manual
                            </li>
                            <li
                              className="dropdown-option list-group-item"
                              onClick={this.handleVimeoClick}
                            >
                              Video Tutorials
                            </li>
                          </ul>
                        )}
                      </li>
                    </li>
                  </ul>
                </div>

                <div className="proImg">
                  {this.state.ProfileDialogvisible && (
                    <Dialog
                      onClose={this.toggleProfileDialog}
                      className="editProfileDialog"
                    >
                      <div className="addUnitForm">
                        <h3>Edit Profile</h3>
                        <div className="formCont">
                          <div className="fieldCol">
                            <div className="fieldCont">
                              <label>Name</label>
                              <input type="text" autoComplete="off" />
                            </div>
                          </div>
                          <div className="fieldCol">
                            <div className="fieldCont">
                              <label>Mobile Number</label>
                              <input type="text" autoComplete="off" />
                            </div>
                          </div>
                          <div className="fieldCol">
                            <div className="fieldCont">
                              <label>Telephone Number</label>
                              <input type="text" autoComplete="off" />
                            </div>
                          </div>
                          <div className="fieldCol">
                            <div className="fieldCont">
                              <label>Email</label>
                              <input type="text" autoComplete="off" />
                            </div>
                          </div>
                          <div className="fieldColTextarea">
                            <div className="fieldCont">
                              <label>Description</label>
                              <textarea></textarea>
                            </div>
                          </div>
                        </div>
                        <div className="btnGroup">
                          <button className="btnPrimary">Update</button>
                          <button
                            className="btnDark"
                            onClick={this.toggleProfileDialog}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </Dialog>
                  )}
                  <div className="dropdown">
                    <a
                      className="imgCont dropdown-toggle"
                      data-toggle="dropdown"
                    >
                      <div className="profileImg">
                        <Dropdown>
                          <Dropdown.Toggle>
                            <div className="profileImg">
                              <img
                                src={Images.AVATAR}
                                width="20"
                                alt="Profile"
                              />
                            </div>
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <div className="userProImgLarge">
                              <div>
                                <div className="proImgWrapper">
                                  <img
                                    src={Images.AVATAR}
                                    width="30"
                                    alt="Profile"
                                  />

                                  {/* <a onClick={ this.showProfileUpload } className="updateProfile" title="Update"  >
                                    <img src={Images.UPLOADICON} width="10"/>
                                  </a> */}

                                  {/* <div className="dragAndDrop">
                                  <Dropzone
                                    onChangeStatus={this.handleChangeStatus}
                                    onSubmit={this.handleSubmit}
                                    submitButtonDisabled={(files) => files.length < 0}
                                    styles={{ dropzone: { minHeight: 40, maxHeight: 100 } }}
                                  />
                                </div> */}
                                </div>

                                <h4>{name ? name.toUpperCase() : "NA"}</h4>
                                {/* <p>{ role ? role.toUpperCase() : "NA" }</p> */}
                              </div>
                            </div>
                            {/* <Dropdown.Item onClick={this.toggleProfileDialog}>
                              <img
                                src={ Images.EDITICON } width="14"
                              />
                              Edit Profile
                            </Dropdown.Item> */}
                            <Dropdown.Item
                              onClick={(e) => this.changePassword(e)}
                            >
                              {" "}
                              <img
                                src={Images.PASSWORD}
                                width="14"
                                alt="Password"
                              />{" "}
                              Change Password
                            </Dropdown.Item>
                            <Dropdown.Item onClick={this.pageNavLogout}>
                              {" "}
                              <img
                                src={Images.LOGOUT}
                                width="14"
                                alt="Profile"
                              />{" "}
                              Logout
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="tenantBody">
            {/* <Router history={history}> */}
            {/* <Switch> */}
            {renderRoutes(TenantAdminRoute)}
            {/* </Switch> */}
            {/* </Router> */}
          </div>
        </div>
      </div>
    );
  }
}
